import actions from "@/store/actions/tempResultAction";
import mutations from "@/store/mutations/tempResultMutations";
import getters from "@/store/getters/tempResultGetter";
/**
 *  tempResult DATA
 */

export default {
  state: {
    futureBaby: '',
    agingShutter: null,
    genderSwitch: null,
    dailyPalm: '',
    maskShow: true,
    ethnicityScanner: null,
    functionList: [],
    canShowSuccessToast: false // 是否应该显示成功弹窗

  },
  mutations: mutations,
  getters: getters,
  actions: actions
};